module.exports = __webpack_public_path__ + "static/S3Domain-42998cb5b84c76838f75871594a90c36.png";